module.exports = __webpack_public_path__ + "img/firewall-setting.cc1ac98.svg";